import { Link } from "react-router-dom";
import { guides } from "@/mocks/guides";

interface GuidePreviewProps {
  limit?: number;
}

export default function GuidePreview({ limit = 2 }: GuidePreviewProps) {
  const list = guides.slice(0, limit);

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
      {list.map((guide) => (
        <Link
          key={guide.id}
          to={`/guide/${guide.id}`}
          className="group flex flex-col overflow-hidden rounded-lg border border-background-200/70 bg-background-50 transition-colors hover:border-primary-300 cursor-pointer"
        >
          <div className="relative w-full h-44 md:h-52 overflow-hidden bg-background-200">
            <img
              src={guide.cover}
              alt={`${guide.title} 配图`}
              title={`${guide.title} - 观影指南`}
              className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
          </div>
          <div className="flex flex-1 flex-col p-4 md:p-5">
            <span className="inline-flex w-fit items-center gap-1 rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs font-medium text-secondary-900">
              <i className="ri-book-open-line text-xs"></i>
              观影指南 · {guide.readTime}
            </span>
            <h3 className="mt-3 font-heading text-base md:text-lg font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700">
              {guide.title}
            </h3>
            <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-700">
              {guide.excerpt}
            </p>
            <span className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-primary-700">
              阅读全文
              <i className="ri-arrow-right-line text-sm"></i>
            </span>
          </div>
        </Link>
      ))}
    </div>
  );
}